export default function About() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-semibold text-gray-900 mb-6">
                    About Tech Article Hub
                </h1>

                {/* INTRO */}
                <p className="text-gray-700 leading-relaxed mb-6">
                    <strong>Tech Article Hub</strong> is an independent technology website
                    created to make tech news and information easy to understand for everyone.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We share clear and simple articles about technology, artificial intelligence,
                    smartphones, software, and the internet. Our goal is to explain complex tech
                    topics in a friendly and helpful way.
                </p>

                {/* WHAT WE DO */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    What We Do
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    At Tech Article Hub, we focus on:
                </p>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>Latest technology news</li>
                    <li>Artificial Intelligence and AI tools</li>
                    <li>Smartphone updates and reviews</li>
                    <li>Software, apps, and digital tools</li>
                    <li>Easy guides and tech explainers</li>
                </ul>

                <p className="text-gray-700 leading-relaxed mb-6">
                    All our articles are written in simple English so readers from the US,
                    UK, and around the world can understand them easily.
                </p>

                {/* MISSION */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Our Mission
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Our mission is to make technology easy, useful, and accessible for everyone.
                    We believe tech content should be clear, honest, and helpful.
                </p>

                {/* WHY TRUST */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Why Trust Tech Article Hub
                </h2>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>We write original and human-written content</li>
                    <li>We avoid misleading or click-bait headlines</li>
                    <li>We focus on accuracy and clarity</li>
                    <li>We explain technology in plain language</li>
                </ul>

                {/* WHO WE ARE */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Who We Are
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub is run by tech enthusiasts who enjoy learning and sharing
                    knowledge. We are not connected to any single brand or company, which allows
                    us to stay independent and unbiased.
                </p>

                {/* AUDIENCE */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Our Audience
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Our content is made for students, beginners, professionals, and anyone
                    who wants clear and simple tech information. No technical background is
                    required to read our articles.
                </p>

                {/* CLOSING */}
                <p className="text-gray-700 leading-relaxed mt-10">
                    Thank you for visiting <strong>Tech Article Hub</strong>. We hope our
                    articles help you understand technology better and stay informed.
                </p>

            </div>
        </div>
    );
}
